module.exports = __webpack_public_path__ + "img/TV_android-series_X7000G.497aee78.png";